<template>
    <div>
        <div class="modal-overlay active" @click="closeDialog()"></div>
        <div class="modal">
            <div class="modal__header">
                <h2 id="renameListModalTitle" class="headline-s">Delete Lists</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="modal__body flex-column" id="renameListModalBody">
                <div class="modal__body--content-wrapper">
                    <p>Are you sure you want to delete these lists?</p>
                </div>
                <table class="table">
                    <thead>
                        <tr>
                            <th class="text-left" data-label="Name">Name</th>
                            <th>Quantity</th>
                            <th>SKUs</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tr v-for="(list,i) in listsToDelete" :key="i" class="table-item">
                        <td class="text-left" data-label="Name"><p>{{ list.name ? list.name : 'Un-named List' }}</p></td>
                        <td class="text-center" data-label="Items"><p>{{ list.total_quantity }} items</p></td>
                        <td class="text-center" data-label="Skus"><p>{{ list.total_skus }} skus</p></td>
                        <td class="text-center" data-label="Total"><p>${{ parseFloat(list.total ?? 0).toFixed(2) }}</p></td>
                    </tr>
                </table>
                <div class="modal__footer flex-row justify-end">
                    <RothcoCta id="submitButton" class="primary" @click.prevent="submit" :inertia="false">
                        Delete
                    </RothcoCta>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { computed, inject} from "vue";
    import { router } from "@inertiajs/vue3";
    import { useLists } from "@/helpers/composables/useList";
    import RothcoCta from "@/components/RothcoCta.vue"
    import CloseIcon from "@icons/closeIcon.svg";
    let route = inject('route');
    let { deleteLists } = useLists({ router, route });
    let modelValue = defineModel();
    
    const dialogRef = inject("dialogRef");

    const listsToDelete = computed(()=>{
        return dialogRef?.value?.data?.lists_to_delete;
    })

    let beforeClose = computed(()=>{
        let defaultFunction = () => {};
        return dialogRef?.value?.data?.beforeClose ?? defaultFunction;
    })

    const closeDialog = function () {
        if (dialogRef.value) {
            dialogRef.value?.close?.();
        } else {
            modelValue.value = false;
        }
    };
    const submit = function () {
        deleteLists(listsToDelete.value, {
            afterFetch: () => {
                beforeClose.value(listsToDelete.value);
                closeDialog();
            }
        })
    };
</script>
